import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import { uniqueId } from 'lodash';
import { convertMoney } from '@/utils/convertMoney';
import FlexTableRow from '@/components/FlexTableRow';
import WideTableCellCenter from '@/components/WideTableCellCenter';
import { ReserveButton } from './ReserveButton';
import { styled } from '@mui/system';
import { format } from 'date-fns';

// const CTABooking = styled('div')`
//   ${style.text.content.bold}
//   text-align: center;
//   color: ${style.color.product3};
//   cursor: pointer;
// `;
const StyledPriceText = styled('div')`
  font-weight: bold;
`;

const getDataInSomeDate = (days: any) => {
  const sortedDays = days
    .filter((item: any) => !!item?.averageMinfare)
    .sort((a: any, b: any) => a?.averageMinfare - b?.averageMinfare);

  return sortedDays;
};

export default function FareInMonthVcms({
  days,
  numberDayInMonth,
  routeName,
  onSearchFlight,
  isDesktop,
  lang,
}: any) {
  const data = getDataInSomeDate(days);
  return (
    <TableContainer
      component={Paper}
      sx={{
        minHeight: '50px',
        mt: '8px',
        boxShadow: 'none',
      }}
    >
      <Table
        sx={{}}
        aria-label="simple table"
      >
        <TableHead>
          <FlexTableRow
            sx={{
              background: 'white',
              border: 0,
            }}
          >
            <WideTableCellCenter
              align="center"
              sx={{ whiteSpace: 'nowrap' }}
            >
              {lang?.FareTable?.routes || 'Hành trình'}
            </WideTableCellCenter>
            <WideTableCellCenter
              sx={{ whiteSpace: 'nowrap' }}
              align="center"
            >
              {lang?.FareTable?.date || 'Ngày'}
            </WideTableCellCenter>
            <WideTableCellCenter
              sx={{ whiteSpace: 'nowrap' }}
              align="center"
            >
              {isDesktop ? (lang?.FareTable?.cheapestPrice || 'Giá rẻ nhất') : (lang?.FareTable?.price || 'Giá')}
            </WideTableCellCenter>
            {isDesktop && (

            <WideTableCellCenter
              sx={{ whiteSpace: 'nowrap' }}
              align="center"
            />
            )}
          </FlexTableRow>
        </TableHead>
        <TableBody>
          {(data || [])?.slice(0, numberDayInMonth).map((row: any) => (
            <FlexTableRow
              key={uniqueId()}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <WideTableCellCenter align="center">{routeName}</WideTableCellCenter>
              <WideTableCellCenter
                sx={{
                  fontWeight: '500',
                }}
                align="center"
              >
                {format(new Date(row.date), 'dd/MM')}
              </WideTableCellCenter>
              <WideTableCellCenter align="center">
                <StyledPriceText>
                  {row?.averageMinfare
                    ? convertMoney(row?.averageMinfare, lang)
                    : 'Đang cập nhật'}
                </StyledPriceText>
                {!isDesktop && (
                  <ReserveButton
                    onClick={() => onSearchFlight({
                      depart: new Date(row.date).toISOString(),
                      return: null,
                    })}
                    lang={lang}
                  />
                )}
              </WideTableCellCenter>
              {isDesktop && (
                <WideTableCellCenter align="center">
                  <ReserveButton
                    onClick={() => onSearchFlight({
                      depart: new Date(row.date).toISOString(),
                      return: null,
                    })}
                    lang={lang}
                  />
                </WideTableCellCenter>
              )}
            </FlexTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
